// Contact Form Handler
document.addEventListener('DOMContentLoaded', function() {
  const contactForm = document.querySelector('form[aria-label="Contact form"]');
  
  if (!contactForm) return;

  const submitButton = contactForm.querySelector('#submit-contact');
  const spinner = contactForm.querySelector('.wpcf7-spinner');

  submitButton.addEventListener('click', function (e) {
    e.preventDefault();

    console.log('submit form');
    // Get form data
    const formData = {
      author: contactForm.querySelector('input[name="your-name"]').value,
      phone: contactForm.querySelector('input[name="your-phone"]').value,
      email: contactForm.querySelector('input[name="your-email"]').value,
      title: contactForm.querySelector('input[name="your-subject"]').value,
      message: contactForm.querySelector('textarea[name="your-message"]').value
    };

    // Validate required fields
    if (!formData.author) {
      contactForm.querySelector('input[name="your-name"]').classList.add('error');
    } else {
      contactForm.querySelector('input[name="your-name"]').classList.remove('error');
    }

    if (!formData.email) {
      contactForm.querySelector('input[name="your-email"]').classList.add('error');
    } else {
      contactForm.querySelector('input[name="your-email"]').classList.remove('error');
    }

    if (!formData.phone) {
      contactForm.querySelector('input[name="your-phone"]').classList.add('error');
    } else {
      contactForm.querySelector('input[name="your-phone"]').classList.remove('error');
    }

    if (!formData.title) {
      contactForm.querySelector('input[name="your-subject"]').classList.add('error');
    } else {
      contactForm.querySelector('input[name="your-subject"]').classList.remove('error');
    }

    if (!formData.message) {
      contactForm.querySelector('textarea[name="your-message"]').classList.add('error');
    } else {
      contactForm.querySelector('textarea[name="your-message"]').classList.remove('error');
    }

    if (!formData.author || !formData.email || !formData.phone || !formData.title || !formData.message) {
      return
    }

    // Show loading state
    submitButton.disabled = true;
    spinner.style.display = 'inline-block';
    contactForm.setAttribute('data-status', 'submitting');

    // Send AJAX request
    fetch('/contacts', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        contactForm.reset();
        contactForm.setAttribute('data-status', 'sent');
        contactForm.querySelector(`span.contact-success`).classList.remove('hide');
        contactForm.querySelector(`span.contact-success`).textContent = data.message;
      } else {
        console.log(data.errors);
        for (const field in data.errors) {
          if (data.errors.hasOwnProperty(field)) {
            contactForm.querySelector(`input[name="your-${field}"]`).classList.add('error');
            console.log(data.errors[field]);
            contactForm.querySelector(`span.${field}-error`).textContent = data.errors[field].first;
          }
        }
        contactForm.setAttribute('data-status', 'failed');
      }
    })
    .catch(error => {
      console.error('Error:', error);
      contactForm.setAttribute('data-status', 'failed');
    })
    .finally(() => {
      submitButton.disabled = false;
      spinner.style.display = 'none';
    });
  });
});

